/**
 * Asset utility function
 * Resolves asset paths for public folder
 */

export function asset(path: string): string {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;

  // Return public path
  return `/${cleanPath}`;
}
